"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _UTTouchableWithoutFeedback = _interopRequireDefault(require("../../../../../UTTouchableWithoutFeedback"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Slide = function Slide(_ref) {
  var keyName = _ref.keyName,
      imgSrc = _ref.imgSrc,
      position = _ref.position,
      widthContainer = _ref.widthContainer,
      currentSlide = _ref.currentSlide,
      border = _ref.border,
      shouldAnimate = _ref.shouldAnimate,
      animationTime = _ref.animationTime,
      onClick = _ref.onClick;
  var slide = currentSlide === position ? border / 2 : currentSlide === position - 1 ? -border / 4 : currentSlide === position + 1 && border + border / 4;
  return _react["default"].createElement(_UTTouchableWithoutFeedback["default"], {
    keyName: keyName,
    className: "".concat(_stylesModule["default"].imageContainer),
    style: {
      left: position * (slide ? widthContainer + slide : widthContainer),
      width: "".concat(border ? widthContainer - border : widthContainer, "px"),
      transition: "".concat(shouldAnimate ? "left ".concat(animationTime, "s linear 0s") : 'none')
    },
    draggable: "false",
    onClick: onClick
  }, _react["default"].createElement("div", {
    style: {
      backgroundImage: "url(".concat(imgSrc, ")")
    },
    className: _stylesModule["default"].image,
    draggable: "false"
  }));
};

Slide.propTypes = {
  position: _propTypes.number,
  imgSrc: _propTypes.string,
  widthContainer: _propTypes.number,
  border: _propTypes.number,
  shouldAnimate: _propTypes.bool,
  currentSlide: _propTypes.number,
  animationTime: _propTypes.number,
  onClick: _propTypes.func,
  keyName: _propTypes.string
};

var _default = (0, _react.memo)(Slide);

exports["default"] = _default;